import ExpandColumn from "./ExpandColumn";
import DevDesSubTabla from "./DevDesSubTabla";

export { DevDesSubTabla, ExpandColumn };
